<template>
  <div class="document-config">
    <div class="table-container">
      <div class="table-header">
        <p class="total-count">总数: {{ total }}</p>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleEdit(1)">新增</el-button>
      </div>
      <el-table class="table-list" :data="tableData" border :stripe="true" :show-overflow-tooltip="true">
        <el-table-column type="index" align="center" label="序号" />
        <el-table-column align="center" prop="title" label="标题" min-width="200" />
        <el-table-column align="center" prop="description" label="描述" min-width="260" />
        <el-table-column align="center" label="内容" min-width="340">
          <template slot-scope="scope">
            <div class="content" v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isTop" label="置顶">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isTop ? 'success' : 'primary'">{{ scope.row.isTop ? "是" : "否" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="sortOrder" label="排序" />
        <el-table-column align="center" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status ? 'success' : 'info'">{{ scope.row.status ? "已发布" : "草稿" }}</el-tag>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 0" type="text" size="small" @click="handleEdit(2, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="changeStatus(scope.row)">{{ scope.row.status ? "撤回" : "发布" }}</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="footer">
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="searchForm.size"
        @current-change="handleCurrentChange"
        @size-change="onChangeSize"
        :current-page="searchForm.current"
      ></el-pagination>
    </div>

    <!-- 编辑弹窗 -->
    <editMessage :editShow="editShow" :editType="editType" :id="messageId" @close="close"></editMessage>
  </div>
</template>

<script>
import {deleteMessage, getMessageList, publishMessage} from "@/api/sysMsg";
import editMessage from "./editMessage.vue";

export default {
  components: {
    editMessage,
  },
  data() {
    return {
      searchForm: {
        current: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      editType: 1, // 编辑类型 1:新增 2:编辑
      messageId: "", // id
      editShow: false // 编辑banner弹窗是否显示
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.getDataList();
    },

    // 获取列表
    async getDataList() {
      try {
        let res = await getMessageList(this.searchForm);
        if (res.code == 200) {
          this.tableData = res.data.rows || [];
          this.total = res.data.total || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 页码改变
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getDataList();
    },

    // 每页条数改变
    onChangeSize(val) {
      this.searchForm.size = val;
      this.searchForm.current = 1;
      this.getDataList();
    },

    // 编辑banner
    handleEdit(type, row) {
      if (type == 1) {
        this.messageId = "";
        this.editType = 1;
      } else if (type == 2) {
        this.editType = 2;
        this.messageId = row.id || "";
      }
      this.editShow = true;
    },

    // 关闭编辑banner弹窗
    close() {
      this.messageId = "";
      this.editShow = false;
      this.getDataList();
    },

    changeStatus(row) {
      this.$confirm(`确认${row.status ? "撤回" : "发布"}消息?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.onChangeStatus(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },

    // 切换状态
    async onChangeStatus(row) {
      try {
        let res = await publishMessage({ id: row.id });
        if (res.code == 200) {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.getDataList();
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确认删除此消息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.onDelete(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 删除
    async onDelete(row) {
      try {
        let res = await deleteMessage({ id: row.id });
        if (res.code == 200) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getDataList();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.document-config {
  padding: 20px;
}

.table-container {
  padding: 10px 20px 20px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 72px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .total-count {
    font-size: 18px;
    font-weight: 600;
  }
}

.table-list {
  font-size: 12px;

  .content {
    // 超出部分省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.footer {
  width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 100;
  padding: 20px;
  box-shadow: 0 -8px 8px -10px rgba(0, 0, 0, 0.2);
  /* 顶部外阴影 */

  .pagination {
    text-align: right;
    padding: 0;
  }
}
</style>
